import React, { useState, useEffect } from "react";
import {
  Autocomplete,
  TextField,
  CircularProgress,
  InputAdornment,
  Box,
  Typography,
} from "@mui/material";
import { Search as SearchIcon, Clear as ClearIcon } from "@mui/icons-material";
import Highlight from "react-highlight-words";
import { useNavigate } from "react-router-dom";
import { useFormContext } from "react-hook-form";
import _debounce from "lodash/debounce";
import useUser from "../hooks/useUser";

const currentPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const UserSearch = () => {
  const {
    formState: { errors },
    control,
    watch,
    setValue,
  } = useFormContext();

  console.log(errors, "errors1234");
  const { globalAutoSearchUser, globalAutoSearchResults } = useUser();
  const [searchValue, setSearchValue] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [highlightWords, setHighlightWords] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [isSearching, setIsSearching] = useState(false);
  const navigate = useNavigate();
  const [searchPayload, setPayload] = useState(currentPayload);

  const handleSearch = async (query) => {
    if (query) {
      const payloadValues = {
        ...searchPayload,
        filters: [
          {
            fieldName: "userName",
            fieldValue: query,
            op: "like",
            dataType: "string",
            condition: "and",
            isJoin: false,
          },
        ],
      };
      setIsSearching(true);
      try {
        await globalAutoSearchUser(payloadValues);
        setHighlightWords([query]);
      } finally {
        setIsSearching(false);
      }
    } else {
      setSearchResults([]);
      setHighlightWords([]);
    }
  };

  const debouncedSearch = _debounce(handleSearch, 300);

  useEffect(() => {
    setSearchResults(globalAutoSearchResults);
  }, [globalAutoSearchResults]);

  // Handle input changes
  const handleInputChange = (event, newInputValue) => {
    if (event.type == "change") {
      setSearchValue(newInputValue);
      debouncedSearch(newInputValue);
    }
  };

  // Handle selection from autocomplete dropdown
  const handleOptionSelect = (event, option) => {
    console.log(option, "optionoptionoption");
    if (typeof option === "object") {
      setValue("selectedUser", {
        label: option.userName,
        value: option.radUserId,
      });
      setSearchValue(option.userName);
    }
  };
  const handleClear = () => {
    setSearchValue("");
    setSearchResults([]);
    setValue("selectedUser", null);
  };

  return (
    <Box
      sx={{
        backgroundColor: (theme) =>
          theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.05)" : "#e0f7fa",
        color: (theme) => (theme.palette.mode === "dark" ? "text.primary" : "#006064"),
        borderRadius: "4px",
      }}
    >
      <Autocomplete
        name="selectedUser"
        freeSolo
        options={searchResults}
        getOptionLabel={(option) =>
          option.userName +
          " - " +
          option.fullName +
          " - " +
          option.mobileNo +
          " - " +
          option.emailId
        }
        inputValue={searchValue}
        value={selectedValue}
        onInputChange={handleInputChange}
        onChange={handleOptionSelect}
        loading={isSearching}
        renderOption={(props, option) => (
          <Box
            component="li"
            {...props}
            key={option.radUserId}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: 1, // Add some padding for spacing
              backgroundColor: (theme) =>
                theme.palette.mode === "dark" ? "background.paper" : "#e0f7fa",
              color: (theme) => (theme.palette.mode === "dark" ? "text.primary" : "#006064"),
            }}
          >
            <Typography
              variant="body1"
              sx={{
                flexBasis: "20%",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              <Highlight
                searchWords={highlightWords}
                autoEscape={true}
                textToHighlight={option.userName || ""}
              />
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              sx={{
                flexBasis: "20%",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              <Highlight
                searchWords={highlightWords}
                autoEscape={true}
                textToHighlight={option.fullName || ""}
              />
            </Typography>

            <Typography
              variant="body2"
              color="textSecondary"
              sx={{
                flexBasis: "25%",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              <Highlight
                searchWords={highlightWords}
                autoEscape={true}
                textToHighlight={option.mobileNo || ""}
              />
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              sx={{
                flexBasis: "40%",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              <Highlight
                searchWords={highlightWords}
                autoEscape={true}
                textToHighlight={option.emailId || ""}
              />
            </Typography>
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Search Users"
            error={!!errors["selectedUser"]}
            helperText={errors["selectedUser"]?.message}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),

              endAdornment: (
                <>
                  {isSearching ? <CircularProgress color="inherit" size={20} /> : null}
                  {searchValue && (
                    <InputAdornment position="end" onClick={handleClear} sx={{ cursor: "pointer" }}>
                      <ClearIcon />
                    </InputAdornment>
                  )}
                </>
              ),
            }}
            fullWidth
          />
        )}
      />
    </Box>
  );
};

export default UserSearch;
